var map = {
	"./WhatsApp Image 2024-03-21 at 14.53.51 (1).jpeg": 8024,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (10).jpeg": 680,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (11).jpeg": 7560,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (13).jpeg": 428,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (14).jpeg": 1092,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (15).jpeg": 5652,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (16).jpeg": 2247,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (3).jpeg": 1216,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (4).jpeg": 9968,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (5).jpeg": 8020,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (6).jpeg": 1296,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (7).jpeg": 9764,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (8).jpeg": 9140,
	"./WhatsApp Image 2024-03-21 at 14.53.51 (9).jpeg": 3304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3024;